import { useEffect } from 'react';

import { isBlockRightClickAndShortcutsEnabled } from '@/app-config';

const useDisableRightClickAndShortcuts = () => {
  useEffect(() => {
    // Disable right-click (context menu)
    const handleContextMenu = (event: MouseEvent) => {
      event.preventDefault();
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for F12
      if (event.keyCode === 123) {
        event.preventDefault();
      }

      // Check for Ctrl+Shift+I
      if (event.ctrlKey && event.shiftKey && event.keyCode === 73) {
        event.preventDefault();
      }

      // Check for Ctrl+U
      if (event.ctrlKey && event.keyCode === 85) {
        event.preventDefault();
      }
    };

    if (isBlockRightClickAndShortcutsEnabled) {
      document.addEventListener('contextmenu', handleContextMenu);
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};

export default useDisableRightClickAndShortcuts;
